/* global getStorageItem:false */
/* global globalMethods:false */

(function() {
	/**
	 * Display correct header button depends to fetched data
	 */

	globalMethods.switchAppButtons = function() {
		var isUserLoggedIn = getStorageItem('account_logged_in') || false;
		var onboardingButtonVisibility = 'none';
		var appButtonVisibility = 'none';

		if (isUserLoggedIn) {
			appButtonVisibility = '';
		} else {
			onboardingButtonVisibility = '';
		}

		var onboardingButtons = document.getElementsByClassName('js-header-button-onboarding');
		[].forEach.call(onboardingButtons, function(onboardingButton) {
			onboardingButton.style.display = onboardingButtonVisibility;
		});

		var appButtons = document.getElementsByClassName('js-header-button-app');
		[].forEach.call(appButtons, function(appButton) {
			appButton.style.display = appButtonVisibility;
		});
	};

	globalMethods.switchAppButtons();



	/**
	 * Show correct action box (contextual sidebar box) depends to fetched data
	 */

	globalMethods.showSidebarActionBox = function() {
		var boxes = document.getElementsByClassName('js-contextual-action-box');
		[].forEach.call(boxes, function(box) {
			var isActionBoxProcessed = box.getAttribute('data-processed');

			// prevent re-running this action for the second time on the same page
			if (isActionBoxProcessed) {
				return;
			}

			box.setAttribute('data-processed', 'true')

			var isUserLoggedIn = getStorageItem('account_logged_in') || false;
			var accountPhase = getStorageItem('account_phase');
			var isAccountCleaned = getStorageItem('account_cleaned');
			var accountExpirationTimestamp = getStorageItem('account_expires_at');

			// we will just display case study box in this case
			if (isUserLoggedIn && accountPhase === 'customer' && !isAccountCleaned) {
				var elements = box.getElementsByClassName('js-contextual-action-box-case-study');
				[].forEach.call(elements, function(element) {
					element.style.display = '';
				});
			} else if (!isUserLoggedIn || isAccountCleaned) {
				var elements = box.getElementsByClassName('js-contextual-action-box-general');
				[].forEach.call(elements, function(element) {
					element.style.display = '';
				});
			} else if (accountExpirationTimestamp) {
				// user is in trial phase
				var accountExpiresAt = new Date(accountExpirationTimestamp);
				var today = new Date();
				var withinFourDays = new Date();
				withinFourDays.setDate(withinFourDays.getDate() + 4);

				if (accountExpiresAt.getTime() > withinFourDays) {
					var elements = box.getElementsByClassName('js-contextual-action-box-case-study');
					[].forEach.call(elements, function(element) {
						element.style.display = '';
					});
				} else if (accountExpiresAt.getTime() > today.getTime()) {
					var elements = box.getElementsByClassName('js-contextual-action-box-ending-trial');
					[].forEach.call(elements, function(element) {
						element.style.display = '';
					});
				} else {
					var elements = box.getElementsByClassName('js-contextual-action-box-trial-ended');
					[].forEach.call(elements, function(element) {
						element.style.display = '';
					});
				}
			} else {
				// just fallback
				var elements = box.getElementsByClassName('js-contextual-action-box-general');
				[].forEach.call(elements, function(element) {
					element.style.display = '';
				});
			}

			var className = 'action-box--is-hidden';
			if (box.classList) {
				box.classList.remove(className);
			} else {
				box.className = box.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
			}
		});
	};

	globalMethods.showSidebarActionBox();
})();
